<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">Seo Info</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">Seo Info</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Info</h6>
            </div>
            <div>
              <ValidationObserver ref="seoAddForm" id="seoAddForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <b-tab :title="language.code" v-for="(language, i) in languages" :key="i">
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label  :for="'title[' + language.code + ']'" class="form-label">Title:</label>
                      <input  :id="'title[' + language.code + ']'" :dir="language.type" class="form-control" :name="'title[' + language.code + ']'" v-model="formData.title[language.code]" :class="checkValidation(classes)" placeholder="title" type="text">
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label :for="'meta_title[' + language.code + ']'" class="form-label">Og Title:</label>
                      <input :id="'meta_title[' + language.code + ']'" :dir="language.type" class="form-control" :name="'meta_title[' + language.code + ']'" v-model="formData.meta_title[language.code]" :class="checkValidation(classes)" placeholder="og title" type="text">
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ classes }"  tag="div" class="form-group">
                      <label :for="'meta_description[' + language.code + ']'" class="form-label">Meta Description:</label>
                      <input :id="'meta_description[' + language.code + ']'" :dir="language.type" class="form-control" :name="'meta_description[' + language.code + ']'" v-model="formData.meta_description[language.code]" :class="checkValidation(classes)" placeholder="meta description" type="text">
                    </ValidationProvider>
                  </b-tab>
                </b-tabs>
                <ImageUpload accept="image/png,image/jpeg,image/jpg" label="Meta Image:" name="image" uploadType="oneImage" type="image" :validation="true" :filesData="[formData.image]" />
                <ValidationProvider v-slot="{ classes }"  tag="div" class="form-group">
                  <label class="form-label">Pages:</label>
                  <select id="categories" class="form-control" name="page" v-model="formData.page" :class="checkValidation(classes)" type="text">
                    <option v-for="(item ,index) in pages" :key="index" :value="item.name">{{item.name}}</option>
                  </select>
                </ValidationProvider>
                <button class="btn ripple btn-main-primary" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ImageUpload from '../../components/ImageUpload'

export default {
  name: 'AddNews',
  data () {
    return {
      buttonDisable: false,
      pages: [
        { name: 'service' },
        { name: 'about' },
        { name: 'blog' },
        { name: 'contacts' },
        { name: 'calculator' },
        { name: 'index' }
      ],
      formData: {
        title: {},
        url: '',
        description: {},
        meta_title: {},
        meta_description: {},
        errClass: false
      },
      uploadedVideoFile: {},
      videoType: 'video_iframe',
      serviceInfoId: null,
      letterCount: '',
      wordCount: ''
    }
  },
  components: {
    ImageUpload
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages
    })
  },
  created () {
    if (this.$route.params.id === 'add') {
      this.isEdit = false
    } else {
      this.isEdit = true
      this.getSeo(this.$route.params.id).then(res => {
        this.formData = res
      })
    }
  },
  methods: {
    ...mapActions({
      getSeo: 'seo/getSeo',
      createSeo: 'seo/createSeo',
      updateSeo: 'seo/updateSeo'
    }),
    checkValidation (data) {
      return data
    },
    formSubmit () {
      this.$refs.seoAddForm.validate().then(success => {
        if (success) {
          this.buttonDisable = true
          const form = document.getElementById('seoAddForm')
          const formData = new FormData(form)
          if (this.$route.params.id === 'add') {
            this.createSeo({ data: formData }).then(res => {
              this.$toasted.success(this.$t('messages.success.newsUpdated')).goAway(1500)
              this.$router.push('/seo')
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          } else {
            this.updateSeo({ data: formData, id: this.$route.params.id }).then(res => {
              this.$toasted.success(this.$t('messages.success.newsUpdated')).goAway(1500)
              this.$router.push('/seo')
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
